import React from 'react';
import {FormattedMessage, IntlProvider} from 'react-intl';

import * as ResourceApi from 'api/resources';
import {enUSmessage} from 'i18n/en-US.js';

export default {
    name: "gallery",
    subSection: true,
    resource: true,
    hideIfResourceIsNoU: true,
    // showSection: (formProxy) => {
    //     return formProxy.currentResource.resourceId.type === ResourceApi.Types.GalleryStep
    // },

    fields: [
        {
            type: 'contenteditable',
            name: 'title',

            props: {
                label: 'Gallery Title',
            }
        },
        {
            type: 'contenteditable',
            name: 'copy',

            props: {
                label: 'Intro Copy',
            }
        },
        {
            type: 'contenteditable',
            name: 'footerCopy',

            props: {
                label: 'Footer Copy',
            }
        },
        {
            type: 'text',
            name: 'groupType',
            required: true,

            props: {
                label: "Gallery group to pull from images from. This needs to match what was specified in the upload step. If you're not sure enter the permalink.",
            }
        },
        {
            type: 'text',
            name: 'sourceCategory',
            required: false,

            props: {
                label: "Optional: category ids to include. Pull the category id from the Media Upload step.To include more than one separate them with commas.",
            }
        },
        {
            type: 'number',
            name: 'columns',
            required: true,
            props: {
              labelKey: 'How many columns? (1-6)',
              min: 1,
              max: 6
            }
        },
        {
            type: 'number',
            name: 'perPage',
            required: true,
            props: {
              labelKey: 'How many items per page/screen? For a 2x2 grid you would specify 4 here. ',
              min: 1,
              max: 64
            }
        },
  
        {
            type: 'yesnoradio',
            name: 'hasVoting',
            required: true,
            props: {
            //   label: 'Can users vote on items?',
                labelKey: 'editbreak.steps.gallery.hasVoting'
            }
        },                
        {
            type: 'text',
            name: 'zeroVotesCopy',

            props: {
                label: 'Copy to show when an item has no votes',
            },

            showField: (proxy) => {
                return (proxy.currentResource.hasVoting === true)
            },


        },
        // {
        //     type: 'yesnoradio',
        //     name: 'hasItemSharing',
        //     required: true,
        //     props: {
        //         labelKey: 'editbreak.steps.gallery.hasItemSharing'
        //     }
        // },


    ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/gallery.js